import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../global/button/Button'
import { useSnackbar } from '../global/context/SnackbarContext'
import IconButton from '../global/iconButton/IconButton'
import { CloseIcon } from '../icons/CloseIcon'
import { TransactionDto } from '../model/TransactionDto'
import { Text, TextSmallStrong } from '../ui/Typography/Typography'
import { Modal } from '../ui/v2/Modal'
import { isOne } from '../utils/validations'

import styles from './TransactionOptionModal.module.scss'

interface Option {
  step: number
  visible: boolean
  data?: TransactionDto
}

interface Props {
  optionModal: Option
  setOptionModal(options: Option): void
  onCancelTransaction(transaction: TransactionDto): Promise<void>
  isOptionDisabled?: boolean
}

export const TransactionOptionModal: React.FC<Props> = ({
  optionModal,
  setOptionModal,
  onCancelTransaction,
  isOptionDisabled,
}) => {
  const { t } = useTranslation()
  const { addSnackbar } = useSnackbar()

  if (isOne(optionModal.step)) {
    return (
      <Modal.Action
        title={t('Transaction')}
        renderFooter={({ onClose }) => [
          <Button appearance='primary' onClick={onClose}>
            <Text>{t('Close')}</Text>
          </Button>,
        ]}
        onClose={() => {
          setOptionModal({
            visible: false,
            step: 1,
            data: undefined,
          })
        }}
      >
        <IconButton
          appearance='ghost'
          onClick={() => {
            isOptionDisabled
              ? addSnackbar.error({ message: t('This action is not available') })
              : setOptionModal({
                  ...optionModal,
                  step: 2,
                })
          }}
        >
          <CloseIcon color={'error'} />
          <Text className={styles.error}>{t('Transactions.Cancel Transaction')}</Text>
        </IconButton>
      </Modal.Action>
    )
  }

  return (
    <Modal.Action
      title={t('Transactions.Cancel Transaction')}
      renderFooter={({ onClose }) => [
        <Button appearance='secondary' onClick={onClose}>
          <TextSmallStrong>{t('Close')}</TextSmallStrong>
        </Button>,
        <Button
          appearance='primary'
          onClick={() => onCancelTransaction(optionModal.data as TransactionDto)}
        >
          <TextSmallStrong>{t('Transactions.Cancel Transaction')}</TextSmallStrong>
        </Button>,
      ]}
      onClose={() => {
        setOptionModal({
          visible: false,
          step: 1,
          data: undefined,
        })
      }}
    >
      <Text>{t('Transactions.Are you sure you want to cancel your transaction')}</Text>
    </Modal.Action>
  )
}
